import React, { useState } from "react";
import { BrowserRouter, createBrowserRouter, RouterProvider } from "react-router-dom";
import "@/App.css";
import "@/design-system/tokens.css";
import "@/design-system/operations.css";
import { UiPreferences } from "./UiPreferences";
import { UnsavedNavigationProvider } from "./UnsavedNavigation";
import { PageRecovery, PageRecoveryBoundary } from "./PageRecovery";

import { AppProviders } from "./providers";
import { AppRouter } from "./router";
import { isSupabaseMode } from "@/lib/backend";
const SupabaseWorkspace = React.lazy(() => import("@/supabase/Workspace"));

function SupabaseRouter() {
  const [router] = useState(() => createBrowserRouter([{ path: "*", errorElement: <PageRecovery />, element:
    <UnsavedNavigationProvider><UiPreferences><AppProviders>
      <React.Suspense fallback={<p role="status">Loading Phoenix…</p>}><SupabaseWorkspace /></React.Suspense>
    </AppProviders></UiPreferences></UnsavedNavigationProvider>,
  }]));
  return <RouterProvider router={router} />;
}

function Application() {
  if (isSupabaseMode) return <SupabaseRouter />;
  return (
    <BrowserRouter>
      <UiPreferences><AppProviders>
        <React.Suspense fallback={<p role="status">Loading Phoenix…</p>}>
          <AppRouter />
        </React.Suspense>
      </AppProviders></UiPreferences>
    </BrowserRouter>
  );
}

export default function App() {
  return <PageRecoveryBoundary><Application /></PageRecoveryBoundary>;
}

